import { use } from 'react';

import { ElectronicClientRecordLocationResultOption } from 'features/organisation/views/organisation-details/components/electronic-client-record/components/link-room-modal/domain/enums/electronic-client-record-location-result-option';
import GetLinkableLocation from 'features/organisation/views/organisation-details/components/electronic-client-record/components/link-room-modal/domain/models/get-linkable-location';
import ElectronicClientRecordProviderContext from '../../../../../providers/contexts/electronic-client-record-context';

interface LinkRoomTableHook {
  onClick: (locationId: string) => void;
}

const useLinkRoomTableHook = (): LinkRoomTableHook => {
  const { locationsData, setSelectedTableRoom, selectedTableRoom } = use(ElectronicClientRecordProviderContext);

  const findLocation = (locations: GetLinkableLocation[], locationId: string): GetLinkableLocation | undefined => {
    for (const location of locations) {
      if (location.id === locationId) {
        return location;
      }

      if (location.children) {
        const found = findLocation(location.children, locationId);
        if (found) {
          return found;
        }
      }
    }

    return undefined;
  };

  const onClick = (locationId: string): void => {
    if (!locationsData) {
      return;
    }

    const location = findLocation(locationsData, locationId);

    if (!location) {
      return;
    }

    if (selectedTableRoom?.id !== location.id) {
      setSelectedTableRoom({
        id: location.id,
        electronicClientRecordLocationId: location.id,
        name: location.name,
        connectorId: location.connectorId,
        result: ElectronicClientRecordLocationResultOption.Success,
      });
    } else {
      setSelectedTableRoom(undefined);
    }
  };

  return {
    onClick,
  };
};

export default useLinkRoomTableHook;
